module.exports = __webpack_public_path__ + "img/logo-b&j.9ecadc08.png";